/**
 * AWS Amplify Configuration
 *
 * Builds Amplify config from environment variables so it works
 * on any deployment platform (Vercel, local dev, etc.) without
 * requiring the auto-generated aws-exports.js file.
 */

import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        username: false,
        phone: false,
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_S3_BUCKET,
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    },
  },
};

Amplify.configure(awsConfig);

export { Amplify };
export default awsConfig;
